import { AddSignerDetail } from './AddSignerDetail'

export default AddSignerDetail
